import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=3aabb8cc&scoped=true"
import script from "./ReminderModal.vue?vue&type=script&lang=js"
export * from "./ReminderModal.vue?vue&type=script&lang=js"
import style0 from "./ReminderModal.vue?vue&type=style&index=0&id=3aabb8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aabb8cc",
  null
  
)

export default component.exports